export default [
  {
    path: '/report/student-lists',
    name: 'report-student-list',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/student-list.vue')
  },
  {
    path: '/report/student-list-for-moeys',
    name: 'report-student-list-for-moeys',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/academic/student-list-for-moeys.vue')
  },
  {
    path: '/report/info-inquiries',
    name: 'report-info-inquiry',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/info-inquiry.vue')
  },
  {
    path: '/report/student-transfers',
    name: 'report-student-transfer',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/student-transfer.vue')
  },
  {
    path: '/report/student-enrollments',
    name: 'report-student-enrollment',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/student-enrollment.vue')
  },
  {
    path: '/report/transportation-lists',
    name: 'report-transportation-list',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/transportation-list.vue')
  },
  {
    path: '/report/inactive-students',
    name: 'report-inactive-student',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/inactive-student.vue')
  },
  {
    path: '/report/student-exchanges',
    name: 'report-student-exchange',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/student-exchange.vue')
  },
  {
    path: '/report/report-cards',
    name: 'report-card',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/report-card.vue')
  },
  {
    path: '/report/report-class-attendances',
    name: 'report/report-class-attendance',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/class-attendance.vue')
  },
  {
    path: '/report/inquiry-follow-ups',
    name: 'report-inquiry-follow-up',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/inquiry-follow-up.vue')
  },
  {
    path: '/report/report-scorings',
    name: 'report-report-scoring',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/report-scoring.vue')
  },
  {
    path: '/report/score-result-list-khmers',
    name: 'score-result-list-khmer',
    meta: { requiresAuth: true },
    component: () =>
      import(
        '@/pages/report/academic/student-score/score-result-list-khmer.vue'
      )
  },
  {
    path: '/report/score-result-list-englishs',
    name: 'score-result-list-english',
    meta: { requiresAuth: true },
    component: () =>
      import(
        '@/pages/report/academic/student-score/score-result-list-english.vue'
      )
  },
  {
    path: '/report/report-card-khmers',
    name: 'report-card-khmer',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/academic/student-score/report-card-khmer.vue')
  },
  {
    path: '/report/report-card-englishs',
    name: 'report-card-english',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/academic/student-score/report-card-english.vue')
  },
  {
    path: '/report/student-achievement-results',
    name: 'student-achievement-result',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/academic/student-achievement-result.vue')
  },
  {
    path: '/report/part-time-of-monthlies',
    name: 'report-part-time-of-montly',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/part-time-of-montly.vue')
  },
  {
    path: '/report/student-score-performance-by-subjects',
    name: 'report-student-score-performance-by-subject',
    meta: { requiresAuth: false },
    component: () => import('@/pages/report/academic/student-score-performance/index.vue')
  },
  {
    path: '/report/student-total-score-performances',
    name: 'report-student-total-score-performance',
    meta: { requiresAuth: false },
    component: () => import('@/pages/report/academic/student-total-score-performance/index.vue')
  },
  {
    path: '/report/student-score-sheets',
    name: 'report-student-score-sheet',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/student-score-sheet.vue')
  },
  {
    path: '/report/monthly-student-summary-reports',
    name: 'monthly-student-summary-report',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/monthly-student-summary-report.vue')
  },
  {
    path: '/report/official-academic-transcripts',
    name: 'official-academic-transcript',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/academic/official-academic-transcript.vue')
  }
]
